import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Eyebrow } from "../components/Section";
import { CAPABILITIES, ADDITIONAL_CAPABILITIES } from "../lib/content";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        num="01"
        title={<>Specialist advisory across <span className="italic text-[var(--bjc-gold)]">four core</span> areas of financial crime risk and AML.</>}
        intro="Each engagement is scoped to deliver clarity, evidence, and defensible outcomes — not generic frameworks."
      />

      <section className="bjc-section">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="space-y-px bg-[var(--bjc-border)] border border-[var(--bjc-border)]">
            {CAPABILITIES.map((c, i) => (
              <div
                key={c.id}
                data-testid={`service-block-${c.id}`}
                className="bg-[var(--bjc-bg)] hover:bg-[var(--bjc-surface)] transition-colors p-8 md:p-12"
              >
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                  <div className="md:col-span-4">
                    <span className="bjc-numeral">— 0{i + 1}</span>
                    <h2 className="mt-4 font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.04] text-[var(--bjc-text)]">
                      {c.title}
                    </h2>
                  </div>
                  <div className="md:col-span-7 md:col-start-6">
                    <p className="text-lg text-[var(--bjc-text)] leading-relaxed">
                      {c.summary}
                    </p>
                    <div className="mt-8 bjc-overline">Includes</div>
                    <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-[var(--bjc-text-muted)]">
                      {c.points.map((p, j) => (
                        <li key={p} data-testid={`service-point-${c.id}-${j}`} className="flex items-start gap-3 text-sm md:text-base">
                          <span className="text-[var(--bjc-gold)] mt-1">·</span>
                          <span>{p}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional capabilities */}
      <section className="bjc-section border-t border-[var(--bjc-border)]" data-testid="additional-capabilities">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Eyebrow num="05">Additional Capabilities</Eyebrow>
            <h2 className="mt-6 font-serif-display text-3xl md:text-4xl text-[var(--bjc-text)] leading-[1.05]">
              Complementary domains we are routinely engaged on.
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <ul className="divide-y divide-[var(--bjc-border)] border-y border-[var(--bjc-border)]">
              {ADDITIONAL_CAPABILITIES.map((a, i) => (
                <li
                  key={a}
                  data-testid={`additional-cap-${i}`}
                  className="py-6 flex items-start gap-6 group"
                >
                  <span className="bjc-numeral pt-1">0{i + 1}</span>
                  <span className="text-xl md:text-2xl font-serif-display text-[var(--bjc-text)] group-hover:text-[var(--bjc-gold)] transition-colors">
                    {a}
                  </span>
                </li>
              ))}
            </ul>
            <div className="mt-12">
              <Link to="/contact" data-testid="services-cta" className="bjc-btn-primary">
                Discuss Your Engagement <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
